import { render, staticRenderFns } from "./order-type.vue?vue&type=template&id=a36afcc8&scoped=true"
import script from "./order-type.vue?vue&type=script&lang=js"
export * from "./order-type.vue?vue&type=script&lang=js"
import style0 from "./order-type.vue?vue&type=style&index=0&id=a36afcc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36afcc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36afcc8')) {
      api.createRecord('a36afcc8', component.options)
    } else {
      api.reload('a36afcc8', component.options)
    }
    module.hot.accept("./order-type.vue?vue&type=template&id=a36afcc8&scoped=true", function () {
      api.rerender('a36afcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/order-type.vue"
export default component.exports